import { Controller } from "@hotwired/stimulus"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

dayjs.extend(relativeTime)

export default class extends Controller {
  static values = {
    time: String
  }

  connect() {
    console.log("TimeAgoController connected")
    if (!this.hasTimeValue) return
    const time = dayjs(this.timeValue)
    this.element.textContent = time.fromNow()
  }

  disconnect() {
    // this.element.textContent = ""
  }
}

